import {Component, Input} from '@angular/core';

@Component({
  selector: 'stoplight-indicator',
  template: `
    <div class="indicator-container indicator-container-good" 
        [ngClass]="{'indicator-container-good': isGood, 
          'indicator-container-warning': isWarning, 
          'indicator-container-danger': isDanger}">
      <i class="fa"
         [ngClass]="{'fa-check': isGood, 
            'fa-exclamation': isWarning, 
            'fa-times': isDanger}"></i>
    </div>
  `,
  styles: [`
    .indicator-container {
      width:22px!important;
      height:22px!important;
      margin: 0 auto!important;
      text-align:center!important;
      border:1px solid #fff!important;
      border-radius:11px!important;
    }
    .indicator-container-good {
      background-color:green!important;
      color:#fff!important;
    }
    .indicator-container-warning {
      background-color: yellow!important;
    }
    .indicator-container-danger {
      background-color: red!important;
      color:#fff!important;
    }
  `]
})
export class StoplightIndicatorComponent {
  @Input() isGood: boolean;
  @Input() isWarning: boolean;
  @Input() isDanger: boolean;
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/modules/core/components/stoplight-indicator.ts